import { TradeTransactionDisplay } from '../models/tradeHistory';

export const DUMMY_TRADE_HISTORY: TradeTransactionDisplay[] = [
  {
    entryTransactionID: 'TXN123AB45',
    exitTransactionID: 'TXN123AB45',
    ticker: 'AAPL',
    company: 'Apple Inc.',
    action: 'Long',
    quantity: 100,
    entryPrice: 15000,
    exitPrice: 15500,
    entryDate: new Date(2023, 5, 10),
    exitDate: new Date(2023, 5, 11),
    profit: 500,
  },
  {
    entryTransactionID: 'TXN678CD90',
    exitTransactionID: 'TXN678CD90',
    ticker: 'MSFT',
    company: 'Microsoft Corporation',
    action: 'Short',
    quantity: 50,
    entryPrice: 12500,
    exitPrice: 12000,
    entryDate: new Date(2023, 5, 11),
    exitDate: new Date(2023, 5, 12),
    profit: -500,
  },
  {
    entryTransactionID: 'TXN234EF56',
    exitTransactionID: 'TXN234EF56',
    ticker: 'AMZN',
    company: 'Amazon.com Inc.',
    action: 'Long',
    quantity: 20,
    entryPrice: 70000,
    exitPrice: 70500,
    entryDate: new Date(2023, 5, 12),
    exitDate: new Date(2023, 5, 13),
    profit: 500,
  },
  {
    entryTransactionID: 'TXN789GH12',
    exitTransactionID: 'TXN789GH12',
    ticker: 'GOOGL',
    company: 'Alphabet Inc.',
    action: 'Short',
    quantity: 30,
    entryPrice: 24000,
    exitPrice: 23500,
    entryDate: new Date(2023, 5, 13),
    exitDate: new Date(2023, 5, 14),
    profit: -500,
  },
  {
    entryTransactionID: 'TXN345IJ78',
    exitTransactionID: 'TXN345IJ78',
    ticker: 'FB',
    company: 'Facebook, Inc.',
    action: 'Long',
    quantity: 100,
    entryPrice: 30000,
    exitPrice: 30500,
    entryDate: new Date(2023, 5, 14),
    exitDate: new Date(2023, 5, 15),
    profit: 500,
  },
  {
    entryTransactionID: 'TXN890KL34',
    exitTransactionID: 'TXN890KL34',
    ticker: 'TSLA',
    company: 'Tesla Inc.',
    action: 'Short',
    quantity: 50,
    entryPrice: 35000,
    exitPrice: 34500,
    entryDate: new Date(2023, 5, 15),
    exitDate: new Date(2023, 5, 16),
    profit: -500,
  },
  {
    entryTransactionID: 'TXN456MN91',
    exitTransactionID: 'TXN456MN91',
    ticker: 'NVDA',
    company: 'NVIDIA Corporation',
    action: 'Long',
    quantity: 200,
    entryPrice: 140000,
    exitPrice: 140500,
    entryDate: new Date(2023, 5, 16),
    exitDate: new Date(2023, 5, 17),
    profit: 500,
  },
  {
    entryTransactionID: 'TXN123OP56',
    exitTransactionID: 'TXN123OP56',
    ticker: 'JPM',
    company: 'JPMorgan Chase & Co.',
    action: 'Short',
    quantity: 100,
    entryPrice: 13000,
    exitPrice: 12500,
    entryDate: new Date(2023, 5, 17),
    exitDate: new Date(2023, 5, 18),
    profit: -500,
  },
  {
    entryTransactionID: 'TXN789QR23',
    exitTransactionID: 'TXN789QR23',
    ticker: 'V',
    company: 'Visa Inc.',
    action: 'Long',
    quantity: 150,
    entryPrice: 25000,
    exitPrice: 25500,
    entryDate: new Date(2023, 5, 18),
    exitDate: new Date(2023, 5, 19),
    profit: 500,
  },
  {
    entryTransactionID: 'TXN345ST89',
    exitTransactionID: 'TXN345ST89',
    ticker: 'PYPL',
    company: 'PayPal Holdings Inc.',
    action: 'Short',
    quantity: 100,
    entryPrice: 22000,
    exitPrice: 21500,
    entryDate: new Date(2023, 5, 19),
    exitDate: new Date(2023, 5, 20),
    profit: -500,
  },
];
